import { put, call } from "redux-saga/effects";

import { BFFAgent } from '../../../../common/BFFAgent';
import {
    GESTION_OPERATIVA_RETRY_OFFER_FAILURE,
    GESTION_OPERATIVA_RETRY_OFFER_SUCCESS
} from '../constants';


export function* retryOfferDMSSaga({ data }) {
    try {
        const res = yield call(BFFAgent.Presupuestador.retryOfferDMS, data)
        if(res) {
            yield put({
                type: GESTION_OPERATIVA_RETRY_OFFER_SUCCESS,
                data: res
            })
        }

    } catch (err) {
        yield put({
            type: GESTION_OPERATIVA_RETRY_OFFER_FAILURE,
            data: { error: err },
        })
    }

}



